(function () {
  'use strict';
  var STORAGE_KEY = 'creditcart.selection.v1';
  var FORMATS = ['either', 'printable', 'interactive', 'both'];
  var DEPTHS = ['detailed', 'directory_only', 'unresolved', 'absent'];
  var FORMAT_LABELS = { printable: 'Printable', interactive: 'Interactive' };

  function canonicalPackId(id) { return id === 'master-console' ? 'master' : id; }
  function validIds(ids) {
    return Array.from(new Set((Array.isArray(ids) ? ids : []).filter(function (id) {
      return typeof id === 'string' && id.length > 0 && id.length <= 200 && !/[\u0000-\u001f]/.test(id);
    })));
  }
  function isApproved(manifest) {
    return !!(manifest && manifest.approved === true && manifest.preview_only !== true && manifest.release_status === 'approved' &&
      typeof manifest.release_id === 'string' && manifest.release_id.length &&
      Array.isArray(manifest.cards) && Array.isArray(manifest.packs));
  }
  function coverageFor(card, packId) {
    var records = card && card.coverage;
    var record = records && (records[canonicalPackId(packId)] || records[packId]);
    return {
      printable: record && DEPTHS.indexOf(record.printable) !== -1 ? record.printable : (card ? 'absent' : 'unresolved'),
      interactive: record && DEPTHS.indexOf(record.interactive) !== -1 ? record.interactive : (card ? 'absent' : 'unresolved')
    };
  }
  function matchCard(card, packId, format) {
    format = FORMATS.indexOf(format) === -1 ? 'either' : format;
    var coverage = coverageFor(card, packId);
    var requested = format === 'printable' || format === 'interactive' ? [format] : ['printable', 'interactive'];
    var detailedFormats = requested.filter(function (key) { return coverage[key] === 'detailed'; });
    var qualifies = !!card && (format === 'either' ? detailedFormats.length > 0 : detailedFormats.length === requested.length);
    var states = requested.map(function (key) { return coverage[key]; });
    var state = qualifies ? 'detailed' : states.indexOf('unresolved') !== -1 ? 'unresolved' :
      ((format === 'both' && states.indexOf('absent') !== -1) ? 'absent' :
        states.indexOf('directory_only') !== -1 ? 'directory_only' : 'absent');
    return { state: state, qualifies: qualifies, formats: detailedFormats, coverage: coverage };
  }
  function matchPack(manifest, packId, ids, format) {
    var uniqueIds = validIds(ids);
    var cards = new Map((manifest && Array.isArray(manifest.cards) ? manifest.cards : []).map(function (card) { return [card.id, card]; }));
    var results = uniqueIds.map(function (id) {
      var card = cards.get(id);
      return Object.assign({ id: id, name: card ? card.name : 'Unrecognized card (' + id + ')', known: !!card }, matchCard(card, packId, format));
    });
    var approved = isApproved(manifest);
    var matched = results.filter(function (result) { return result.qualifies; }).length;
    return {
      approved: approved, complete: approved && results.length > 0 && matched === results.length,
      matched: matched, total: results.length, results: results,
      missing: results.filter(function (result) { return result.state === 'absent'; }),
      directory: results.filter(function (result) { return result.state === 'directory_only'; }),
      unresolved: results.filter(function (result) { return result.state === 'unresolved'; })
    };
  }
  function readSelection() {
    var empty = { version: 1, release_id: null, card_ids: [], format: 'either' };
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || parsed.version !== 1) return empty;
      return { version: 1, release_id: typeof parsed.release_id === 'string' ? parsed.release_id : null,
        card_ids: validIds(parsed.card_ids), format: FORMATS.indexOf(parsed.format) !== -1 ? parsed.format : 'either' };
    } catch (error) { return empty; }
  }
  var api = { isApproved: isApproved, matchCard: matchCard, matchPack: matchPack,
    coverageFor: coverageFor, canonicalPackId: canonicalPackId, readSelection: readSelection, storageKey: STORAGE_KEY };
  window.CreditCartCoverage = api;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function initialize(root) {
    if (root.dataset.ccInitialized) return;
    root.dataset.ccInitialized = 'true';
    var config;
    try { config = JSON.parse(root.querySelector('[data-cc-product-config]').textContent); }
    catch (error) { return; }
    var stored = readSelection();
    var state = { manifest: null, cards: [], cardMap: new Map(), issuers: new Map(), selected: new Set(stored.card_ids),
      format: stored.format, audience: stored.card_ids.length ? 'all' : 'personal', limit: 60,
      savedRelease: stored.release_id, needsReview: false };
    var bank = root.querySelector('[data-cc-bank]');
    var search = root.querySelector('[data-cc-search]');
    var options = root.querySelector('[data-cc-card-options]');
    var chips = root.querySelector('[data-cc-selection-chips]');
    var clear = root.querySelector('[data-cc-clear]');
    var status = root.querySelector('[data-cc-catalogue-status]');
    var resultsSummary = root.querySelector('[data-cc-results-summary]');
    var packElements = Array.from(root.querySelectorAll('[data-cc-pack]'));
    var launchReady = root.dataset.launchReady === 'true';

    function save() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ version: 1,
          release_id: state.needsReview ? state.savedRelease : state.manifest ? state.manifest.release_id : state.savedRelease,
          card_ids: Array.from(state.selected), format: state.format }));
      } catch (error) { /* Matching remains usable if browser storage is unavailable. */ }
      window.dispatchEvent(new CustomEvent('creditcart:selectionchange', { detail: readSelection() }));
    }
    function issuerName(card) {
      var issuer = state.issuers.get(card.issuer_id);
      return issuer ? issuer.name : card.issuer_id || 'Other';
    }
    function cardSearchText(card) {
      return [card.name, issuerName(card)].concat(Array.isArray(card.aliases) ? card.aliases : []).join(' ').toLocaleLowerCase();
    }
    function showCatalogueStatus() {
      status.replaceChildren();
      status.dataset.state = isApproved(state.manifest) ? 'approved' : 'preview';
      if (state.needsReview) {
        status.appendChild(element('span', '', 'The catalogue edition changed. Review your saved cards against this edition. '));
        var review = element('button', 'cc-home-text-link', 'Use this edition');
        review.type = 'button';
        review.addEventListener('click', function () { state.needsReview = false; state.savedRelease = state.manifest.release_id; save(); showCatalogueStatus(); renderPacks(); });
        status.appendChild(review);
      } else if (isApproved(state.manifest)) {
        status.textContent = 'Choose card names to compare the published pack coverage.';
      } else {
        status.textContent = 'Preview catalogue · pack coverage under review. Explore card names; confirmed matches will follow.';
      }
    }
    function renderOptions() {
      options.replaceChildren();
      if (!state.manifest) { options.appendChild(element('p', 'cc-empty-note', 'The card catalogue is unavailable. You can still browse the pack descriptions below.')); return; }
      var query = search.value.trim().toLocaleLowerCase();
      var matches = state.cards.filter(function (card) {
        return (!bank.value || card.issuer_id === bank.value) && (!query || cardSearchText(card).indexOf(query) !== -1);
      });
      if (!matches.length) {
        options.appendChild(element('p', 'cc-empty-note', 'No cards found. Try a shorter name or choose another bank. A missing name does not confirm coverage in any pack.'));
        return;
      }
      matches.slice(0, state.limit).forEach(function (card) {
        var label = element('label', 'cc-card-option');
        var checkbox = element('input');
        checkbox.type = 'checkbox'; checkbox.value = card.id; checkbox.checked = state.selected.has(card.id);
        checkbox.addEventListener('change', function () {
          if (checkbox.checked) state.selected.add(card.id); else state.selected.delete(card.id);
          state.audience = 'all'; save(); renderChips(); renderPacks();
        });
        var text = element('span', '', card.name);
        text.appendChild(element('small', '', issuerName(card)));
        label.appendChild(checkbox); label.appendChild(text); options.appendChild(label);
      });
      if (matches.length > state.limit) {
        var more = element('button', 'cc-home-text-link cc-load-more', 'Show more cards (' + Math.min(state.limit, matches.length) + ' of ' + matches.length + ')');
        more.type = 'button';
        more.addEventListener('click', function () { var oldLimit = state.limit; state.limit += 60; renderOptions(); var next = options.querySelectorAll('input')[oldLimit]; if (next) next.focus(); });
        options.appendChild(more);
      }
    }
    function renderChips() {
      chips.replaceChildren();
      root.querySelector('[data-cc-selection-count]').textContent = state.selected.size + (state.selected.size === 1 ? ' card selected' : ' cards selected');
      clear.disabled = state.selected.size === 0;
      if (!state.selected.size) { chips.appendChild(element('p', 'cc-empty-note', 'Choose a card above to begin. You can add cards from several banks.')); return; }
      state.selected.forEach(function (id) {
        var card = state.cardMap.get(id);
      var name = card ? card.name + ' · ' + issuerName(card) : 'Unrecognized card (' + id + ')';
        var chip = element('span', 'cc-chip');
        chip.dataset.unresolved = String(!card);
        chip.appendChild(element('span', '', name));
        var remove = element('button', '', '×');
        remove.type = 'button'; remove.setAttribute('aria-label', 'Remove ' + name);
        remove.addEventListener('click', function () {
          state.selected.delete(id); save(); renderOptions(); renderChips(); renderPacks();
          var next = chips.querySelector('button'); if (next) next.focus(); else search.focus();
        });
        chip.appendChild(remove); chips.appendChild(chip);
      });
    }
    function packRecord(packId) {
      return state.manifest && state.manifest.packs.find(function (pack) { return canonicalPackId(pack.id) === canonicalPackId(packId); });
    }
    function isAvailable(product) {
      var pack = packRecord(product.id);
      return isApproved(state.manifest) && !state.needsReview && launchReady && product.available === true &&
        product.currency === 'INR' && product.price_minor === product.approved_price_minor &&
        product.releaseId === state.manifest.release_id && !!pack && pack.available === true && pack.approved === true && pack.release_status === 'approved';
    }
    function coverageDescription(result) {
      if (result.qualifies) return 'Detailed · ' + result.formats.map(function (format) { return FORMAT_LABELS[format]; }).join(' + ');
      if (!result.known) return 'Unresolved selection';
      var requested = state.format === 'printable' || state.format === 'interactive' ? [state.format] : ['printable', 'interactive'];
      return requested.map(function (format) {
        var depth = result.coverage[format];
        var label = depth === 'directory_only' ? 'directory only' : depth === 'unresolved' ? 'under review' : depth === 'detailed' ? 'detailed' : 'not included';
        return FORMAT_LABELS[format] + ': ' + label;
      }).join(' · ');
    }
    function renderPacks() {
      var approved = isApproved(state.manifest);
      var ids = Array.from(state.selected);
      var matches = config.map(function (product) {
        return { product: product, result: matchPack(state.manifest, product.id, ids, state.format), available: isAvailable(product) };
      });
      var exact = matches.filter(function (match) { return match.result.complete && match.available; }).sort(function (a, b) {
        return a.product.price_minor - b.product.price_minor || a.product.order - b.product.order;
      });
      var recommendation = exact.length ? exact[0].product.id : null;
      root.querySelectorAll('[data-cc-audience]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.ccAudience === state.audience));
      });
      packElements.forEach(function (cardElement) {
        var id = cardElement.dataset.ccPack;
        var match = matches.find(function (entry) { return entry.product.id === id; });
        var pack = packRecord(id);
        var coverage = cardElement.querySelector('[data-cc-pack-coverage]');
        var badge = cardElement.querySelector('[data-cc-pack-match]');
        cardElement.hidden = state.audience !== 'all' && match.product.audience !== state.audience;
        cardElement.dataset.recommended = String(id === recommendation);
        badge.hidden = !approved || !ids.length || !match.result.complete;
        badge.textContent = id === recommendation ? 'Lowest-priced match for your selection' : 'Detailed coverage for your selection';
        if (!match.available) badge.hidden = true;
        coverage.replaceChildren();
        if (!state.manifest) coverage.textContent = 'Card coverage is unavailable. Review the exact card list before purchase.';
        else if (!ids.length) coverage.textContent = approved ? 'Choose your cards to compare detailed coverage.' : 'Preview catalogue · coverage under review.';
        else if (!approved) {
          coverage.appendChild(element('strong', '', ids.length + (ids.length === 1 ? ' card selected' : ' cards selected')));
          coverage.appendChild(element('span', '', 'Coverage under review for ' + (state.format === 'both' ? 'both formats' : state.format === 'either' ? 'your selected cards' : state.format + ' format') + '. No confirmed match yet.'));
        } else {
          coverage.appendChild(element('strong', '', 'Detailed coverage for ' + match.result.matched + ' of your ' + match.result.total + ' selected cards'));
          var list = element('ul', 'cc-coverage-lines');
          match.result.results.forEach(function (result) {
            var line = element('li'); line.dataset.state = result.state;
            var resultCard = state.cardMap.get(result.id);
            line.appendChild(element('span', '', result.name + (resultCard ? ' (' + issuerName(resultCard) + ')' : '') + ' — '));
            line.appendChild(document.createTextNode(coverageDescription(result))); list.appendChild(line);
          });
          coverage.appendChild(list);
          if (state.needsReview) coverage.appendChild(element('p', 'cc-roster-note', 'Review the new edition above to refresh your matches.'));
        }
        if (pack && Array.isArray(pack.formats)) {
          var labels = pack.formats.filter(function (format) { return FORMAT_LABELS[format]; }).map(function (format) { return FORMAT_LABELS[format]; });
          cardElement.querySelector('[data-cc-pack-format]').textContent = labels.join(' + ') + (approved ? '' : ' · preview');
        }
        var details = cardElement.querySelector('.cc-pack-details');
        if (details.open) renderRoster(cardElement);
      });
      var sorted = matches.slice().sort(function (a, b) {
        if (approved && ids.length && !state.needsReview) {
          var aComplete = a.result.complete && a.available;
          var bComplete = b.result.complete && b.available;
          if (aComplete !== bComplete) return aComplete ? -1 : 1;
          if (aComplete && bComplete) return a.product.price_minor - b.product.price_minor || a.product.order - b.product.order;
          if (a.result.matched !== b.result.matched) return b.result.matched - a.result.matched;
        }
        return a.product.order - b.product.order;
      });
      var grid = root.querySelector('[data-cc-pack-grid]');
      sorted.forEach(function (entry) {
        var cardElement = packElements.find(function (node) { return node.dataset.ccPack === entry.product.id; });
        if (cardElement) grid.appendChild(cardElement);
      });
      resultsSummary.dataset.state = recommendation ? 'match' : 'default';
      if (!state.manifest) resultsSummary.textContent = 'The card catalogue is unavailable. Browse the pack descriptions; matching cannot be confirmed right now.';
      else if (!ids.length) resultsSummary.textContent = 'Explore ' + (state.audience === 'all' ? 'all packs' : state.audience === 'master' ? 'the master encyclopedia' : state.audience + ' packs') + ', or select your cards for a closer look.';
      else if (!approved) resultsSummary.textContent = ids.length + ' selected · Preview catalogue. Pack coverage is under review; no confirmed match or purchase recommendation is being made.';
      else if (state.needsReview) resultsSummary.textContent = 'The catalogue edition changed. Review your saved selection above before relying on matches.';
      else if (recommendation) resultsSummary.textContent = exact[0].product.title + ' is the lowest-priced available match for all ' + ids.length + ' selected ' + (ids.length === 1 ? 'card' : 'cards') + ' in ' + (state.format === 'either' ? 'at least one format per card.' : state.format === 'both' ? 'both formats.' : state.format + ' format.');
      else if (matches.some(function (match) { return match.result.complete; })) resultsSummary.textContent = 'A pack covers your selection, but no complete match is currently available to purchase. Review the coverage below.';
      else resultsSummary.textContent = 'No single pack covers all your selected cards in the requested format. Review the detailed and missing cards below.';
    }
    function renderRoster(cardElement) {
      var packId = cardElement.dataset.ccPack;
      var searchInput = cardElement.querySelector('[data-cc-roster-search]');
      var note = cardElement.querySelector('[data-cc-roster-note]');
      var list = cardElement.querySelector('[data-cc-roster-list]');
      list.replaceChildren();
      if (!state.manifest) { searchInput.disabled = true; note.textContent = 'The card list is currently unavailable. Check the exact published coverage before purchasing.'; return; }
      searchInput.disabled = false;
      var approved = isApproved(state.manifest);
      var query = searchInput.value.trim().toLocaleLowerCase();
      var roster = state.cards.filter(function (card) {
        var record = card.coverage && (card.coverage[canonicalPackId(packId)] || card.coverage[packId]);
        if (!record) return false;
        var observed = approved ? record.printable === 'detailed' || record.printable === 'directory_only' || record.interactive === 'detailed' || record.interactive === 'directory_only' :
          record.interactive === 'detailed' || record.interactive === 'directory_only' || record.complete_book === 'present';
        return observed && (!query || cardSearchText(card).indexOf(query) !== -1);
      });
      note.textContent = approved ? roster.length + ' card entries. Coverage depth is shown separately for each format.' : 'Preview card roster · ' + roster.length + ' names' + (query ? ' matching your search' : '') + '. Exact per-format coverage is under review.';
      if (!roster.length) { list.appendChild(element('p', 'cc-empty-note', 'No card names match this search.')); return; }
      var fragment = document.createDocumentFragment();
      roster.forEach(function (card) {
        var item = element('div', 'cc-roster-item', card.name);
        if (approved) {
          var result = Object.assign({ known: true }, matchCard(card, packId, 'both'));
          var perFormat = ['printable', 'interactive'].map(function (format) {
            var depth = result.coverage[format];
            return FORMAT_LABELS[format] + ': ' + (depth === 'directory_only' ? 'directory only' : depth === 'unresolved' ? 'under review' : depth === 'absent' ? 'not included' : 'detailed');
          }).join(' · ');
          item.appendChild(element('small', '', issuerName(card) + ' · ' + perFormat));
        } else item.appendChild(element('small', '', issuerName(card) + ' · Coverage under review'));
        fragment.appendChild(item);
      });
      list.appendChild(fragment);
    }
    bank.addEventListener('change', function () { state.limit = 60; renderOptions(); });
    search.addEventListener('input', function () { state.limit = 60; renderOptions(); });
    clear.addEventListener('click', function () { state.selected.clear(); state.needsReview = false; save(); renderOptions(); renderChips(); renderPacks(); if (state.manifest) showCatalogueStatus(); });
    root.querySelectorAll('.cc-format-options input').forEach(function (input) {
      input.checked = input.value === state.format;
      input.addEventListener('change', function () { state.format = input.value; save(); renderPacks(); });
    });
    root.querySelectorAll('[data-cc-audience]').forEach(function (button) {
      button.addEventListener('click', function () { state.audience = button.dataset.ccAudience; renderPacks(); });
    });
    root.querySelectorAll('[data-cc-select-format]').forEach(function (link) {
      link.addEventListener('click', function () {
        state.format = link.dataset.ccSelectFormat;
        root.querySelectorAll('.cc-format-options input').forEach(function (input) { input.checked = input.value === state.format; });
        save(); renderPacks();
      });
    });
    root.querySelector('[data-cc-explore]').addEventListener('click', function () { state.audience = 'all'; renderPacks(); });
    packElements.forEach(function (cardElement) {
      cardElement.querySelector('.cc-pack-details').addEventListener('toggle', function (event) { if (event.target.open) renderRoster(cardElement); });
      cardElement.querySelector('[data-cc-roster-search]').addEventListener('input', function () { renderRoster(cardElement); });
    });
    renderChips(); renderPacks();
    fetch(root.dataset.coverageUrl, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Catalogue unavailable'); return response.json();
    }).then(function (manifest) {
      if (!manifest || manifest.schema_version !== 1 || !Array.isArray(manifest.cards) || !Array.isArray(manifest.issuers) || !Array.isArray(manifest.packs) || typeof manifest.release_id !== 'string') throw new Error('Invalid catalogue');
      var cardIds = new Set();
      manifest.cards.forEach(function (card) {
        if (!card || typeof card.id !== 'string' || !card.id || typeof card.name !== 'string' || !card.name || typeof card.issuer_id !== 'string' || cardIds.has(card.id)) throw new Error('Invalid card identity');
        cardIds.add(card.id);
      });
      state.manifest = manifest;
      state.cards = manifest.cards.slice().sort(function (a, b) { return a.name.localeCompare(b.name, 'en-IN'); });
      state.cardMap = new Map(state.cards.map(function (card) { return [card.id, card]; }));
      state.issuers = new Map(manifest.issuers.map(function (issuer) { return [issuer.id, issuer]; }));
      state.needsReview = !!(state.selected.size && state.savedRelease && state.savedRelease !== manifest.release_id);
      manifest.issuers.slice().sort(function (a, b) { return a.name.localeCompare(b.name, 'en-IN'); }).forEach(function (issuer) {
        var option = element('option', '', issuer.name + (issuer.kind === 'editorial_group' ? ' — collection' : ''));
        option.value = issuer.id; bank.appendChild(option);
      });
      bank.disabled = false; search.disabled = false;
      showCatalogueStatus(); renderOptions(); renderChips(); renderPacks();
      if (!state.needsReview) save();
    }).catch(function () {
      state.manifest = null; status.dataset.state = 'error';
      status.textContent = 'The card catalogue could not load. Browse the packs below, or reload this page to try again.';
      renderOptions(); renderChips(); renderPacks();
    });
  }
  function start() { document.querySelectorAll('[data-cc-home]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-cc-home]').forEach(initialize);
  });
}());
